import { useTranslation } from "react-i18next";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface OtpCodeInputProps {
  id: string;
  value: string;
  onChange: (value: string) => void;
  error?: string | null;
  disabled?: boolean;
}

/** 6-digit email / authenticator code field for the Settings dialogs. */
export function OtpCodeInput({ id, value, onChange, error, disabled }: OtpCodeInputProps) {
  const { t } = useTranslation("settings");

  return (
    <div className="space-y-1.5">
      <Label htmlFor={id}>{t("verifyIdentity.codeLabel")}</Label>
      <Input
        id={id}
        value={value}
        onChange={(e) => {
          if (/^\d{0,6}$/.test(e.target.value)) onChange(e.target.value);
        }}
        inputMode="numeric"
        autoComplete="one-time-code"
        placeholder="••••••"
        maxLength={6}
        aria-invalid={!!error}
        disabled={disabled}
        autoFocus
        className="h-10 tracking-[0.3em]"
      />
      {error && <p className="text-xs text-red-600">{error}</p>}
    </div>
  );
}
